import * as React from 'react';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';




const BeneficiaryAvatarImage = props => {
  const {avatarUrl, className} = props;
  return (
    <div
      className={classNames('beneficiary-avatar-form d-flex flex-column align-items-center text-align btn-lik' +
        'e',
    className)}>
      <div className='add-plus-button add-image-btn d-none d-sm-block'/>
        <img src={avatarUrl}/>
      <Button variant='link' className='d-block d-sm-none'>
        <u>Upload Image</u>
      </Button>
    </div>
  );
};

export default BeneficiaryAvatarImage;